export default {_name:'Link.Decorated',module:'Field',view:'Element/Button/DecoratedLink',options:{color:'textPrimary',md:12,decorators:{link:true}}}